import { computed } from 'vue'
import { useQuery, useQueryClient } from '@tanstack/vue-query'
import { rpc } from '../api'
import { session } from '../session'

export function useProductFeed() {
  const qc = useQueryClient()
  const company = computed(() => session.boot?.company)

  const query = useQuery({
    queryKey: computed(() => ['product-feed', company.value]),
    queryFn: () =>
      rpc('church_erp.church_erp.utils.platform_api.get_product_feed', {
        company: company.value,
      }),
    enabled: computed(() => !!session.boot?.authenticated),
    staleTime: 60_000,
  })

  const showTerms = computed(() => !!query.data.value?.terms?.required)
  const announcements = computed(() => query.data.value?.announcements || [])
  const tenant = computed(() => query.data.value?.tenant || null)

  async function acceptTerms() {
    await rpc('church_erp.church_erp.utils.platform_api.accept_terms')
    await qc.invalidateQueries({ queryKey: ['product-feed'] })
  }

  return {
    query,
    showTerms,
    announcements,
    tenant,
    acceptTerms,
  }
}
